export default __webpack_public_path__ + "static/media/rfid.1923a972.svg";